// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");
require("component-leaflet-map");

const $ = require('jquery');

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(function() {
// TENT SURVEY MAP STUFF ///
var elementTwo = document.querySelector("#before-after leaflet-map");
var Leaf = elementTwo.leaflet;
var mapTwo = elementTwo.map;

// map.options.maxZoom = 13;
// map.options.minZoom = 11;
// map.scrollWheelZoom.disable();

mapTwo.options.maxZoom = 13;
mapTwo.options.minZoom = 9;
// mapTwo.scrollWheelZoom.disable();


  var imageUrl = './assets/Main-NoBack.png',
  imageBounds = [[47.7342513, -122.24927], [47.514794, -122.41683]];
  var myOverlay = L.imageOverlay(imageUrl, imageBounds).addTo(mapTwo);
  myOverlay.getElement().style.opacity = 0;

  var imageUrl2 = './assets/Fall19_NoBack.png',
  imageBounds2 = [[ 47.5453927,  -122.38732], [47.727928, -122.2989]];
  var myOverlay2 = Leaf.imageOverlay(imageUrl2, imageBounds2).addTo(mapTwo);
  myOverlay2.getElement().style.opacity = 0;

  var imageUrl3 = './assets/summer20_NoBack.png',
  imageBounds3 = [[ 47.5278921,  -122.38793], [47.7344189, -122.29000]];
  var myOverlay3 = Leaf.imageOverlay(imageUrl3, imageBounds3).addTo(mapTwo);
  myOverlay3.getElement().style.opacity = 0.6;

  document.querySelectorAll('.buttonDiv button').forEach(el => el.addEventListener('click', () => {
    myOverlay3.getElement().style.opacity = 0;
    myOverlay2.getElement().style.opacity = 0;
    myOverlay.getElement().style.opacity = 0;
    if(el.classList[0] === "summer"){
      myOverlay3.getElement().style.opacity = 0.6;
      document.querySelector('.buttonDiv button.summer19').classList.remove('selected');
      document.querySelector('.buttonDiv button.summer').classList.add('selected');
      document.querySelector('.buttonDiv button.fall').classList.remove('selected');
    } else if (el.classList[0] === "fall"){
      myOverlay2.getElement().style.opacity = 0.6;
      document.querySelector('.buttonDiv button.summer19').classList.remove('selected');
      document.querySelector('.buttonDiv button.summer').classList.remove('selected');
      document.querySelector('.buttonDiv button.fall').classList.add('selected');
    } else {
      myOverlay.getElement().style.opacity = 0.6;
      document.querySelector('.buttonDiv button.summer19').classList.remove('selected');
      document.querySelector('.buttonDiv button.summer').classList.remove('selected');
      document.querySelector('.buttonDiv button.fall').classList.remove('selected');
    }
  }));



var elementTinyHouse = document.querySelector("#tinyHouseMap leaflet-map");
var LeafTinyHouse = elementTinyHouse.leaflet;
var mapTinyHouse = elementTinyHouse.map;
var markers = [];
var markergroup = L.featureGroup();

window.course.forEach(function(data) {
  let dotColor = "";

  dotColor = (data.Construction === "Y") ? "dot underContruction" : 'dot';


  var marker = L.marker([data.Lat, data.Long], {
    icon: L.divIcon({
      className: dotColor
    })
  });
  var html = `
    <b>${data.Name}</b>
    <br><a href="https://www.google.com/maps/search/?api=1&query=${data.Lat},${data.Long}" target="_blank" rel="noopener noreferrer"/>${data.Address}</a><br>
  `;
  marker.bindPopup(html);
  markers.push(marker);
  marker.addTo(markergroup);
});

markergroup.addTo(mapTinyHouse);

mapTinyHouse.setView(new L.LatLng(47.786644057983494, -122.27308195766904), 8);

mapTinyHouse.scrollWheelZoom.disable();





// require("component-responsive-frame/child");

if ($(window).width() < 700) {
   $('.desktop').hide();
   $('.mobile').show();

   document.querySelectorAll('.box').forEach(el => {
      var boxNumber = el.dataset.num;
      var conSet = el.parentNode.dataset.set;
      var findExpand = document.querySelector(`.expandContainer[data-set="${conSet}"]`);
      var theRightExpand = findExpand.querySelector(`.expand[data-num="${boxNumber}"]`);
      el.after(theRightExpand);
  });
} else {
  $('.desktop').show();
  $('.mobile').hide();
}





$( ".box" ).click(function() {
  var number = $(this).data("num");
  var set = $(this).closest('.container').data("set");
  var expandCon = ($(window).width() >= 700) ? $('#data-page').find(`.expandContainer[data-set="${set}"]`) : $(this).closest('.container');


  if ( $(this).hasClass("selected") ) {

    expandCon.find(`.expand[data-num="${number}"]`).hide();
    $(this).removeClass('selected');
    $(this).find('.chevs').removeClass('selected');

    if ($(window).width() >= 700) {
      $(this).closest('.container').find('.box').removeClass('highlightRow');
    }
  } else {
    if ($(window).width() >= 700) {
      expandCon.find('.expand').hide();
      $(this).closest('.container').find('.box').removeClass('selected');
      $(this).closest('.container').find('.chevs').removeClass('selected');
      $(this).closest('.container').find('.box').addClass('highlightRow');
    }

    $(this).addClass('selected');
    $(this).find('.chevs').addClass('selected');
    // $('#data-page').find(`.expandContainer[data-set="${set}"]`).css("color","red");
    expandCon.find(`.expand[data-num="${number}"]`).show();

    if ( (number === 1) && (set === 2)){
      // map.invalidateSize();
      mapTwo.invalidateSize();
    }
    if ( (number === 2) && (set === 2)){
      // map.invalidateSize();
      mapTinyHouse.invalidateSize();
    }
  }
});

});
